import * as fabric from 'office-ui-fabric-react';
import React, { FC } from 'react';
import * as models from '../../models';
import AdministrationOrganizationsGridItem from './AdministrationOrganizationsGridItem';

interface IProps {
    organizations: models.IOrganization[];
}

const styles = fabric.mergeStyleSets({
    root: {
        padding: 50,
        justifyContent: 'center',
        background: fabric.getTheme().palette.themeTertiary,
        selectors: {
            '& InstitutionCard': {
                width: 50,
                height: 50,
                background: fabric.getTheme().palette.themePrimary,
                color: fabric.getTheme().palette.white
            }
        }
    }
});

const tokens = {
    sectionStack: {
        childrenGap: 50
    },
    wrapStack: {
        childrenGap: 40
    }
};

const AdministrationOrganizationsGrid: FC<IProps> = (props: IProps) => {
    const { organizations } = props;

    return (
        <fabric.Stack tokens={tokens.sectionStack}>
            <fabric.Stack horizontal wrap tokens={tokens.wrapStack} theme={fabric.getTheme()} className={styles.root}>
                {organizations.map(x => (
                    <AdministrationOrganizationsGridItem key={x.id} organization={x} />
                ))}
            </fabric.Stack>
        </fabric.Stack>
    );
};

export default AdministrationOrganizationsGrid;
